import { css } from '@linaria/core';

export const sizes = {
  padding: {
    xsmall: 1,
    small: 2,
    medium: 3,
    large: 4,
    xlarge: 5
  },
  margin: {
    xsmall: 1,
    small: 2,
    medium: 3,
    large: 4,
    xlarge: 5,
    auto: 'auto'
  }
};

export const classes = {
  'p-1': css`padding: 0.25rem !important;`,
  'p-2': css`padding: 0.5rem !important;`,
  'p-3': css`padding: 1rem !important;`,
  'p-4': css`padding: 1.5rem !important;`,
  'p-5': css`padding: 3rem !important;`,

  'pt-1': css`padding-top: 0.25rem !important;`,
  'pt-2': css`padding-top: 0.5rem !important;`,
  'pt-3': css`padding-top: 1rem !important;`,
  'pt-4': css`padding-top: 1.5rem !important;`,
  'pt-5': css`padding-top: 3rem !important;`,

  'pr-1': css`padding-right: 0.25rem !important;`,
  'pr-2': css`padding-right: 0.5rem !important;`,
  'pr-3': css`padding-right: 1rem !important;`,
  'pr-4': css`padding-right: 1.5rem !important;`,
  'pr-5': css`padding-right: 3rem !important;`,

  'pb-1': css`padding-bottom: 0.25rem !important;`,
  'pb-2': css`padding-bottom: 0.5rem !important;`,
  'pb-3': css`padding-bottom: 1rem !important;`,
  'pb-4': css`padding-bottom: 1.5rem !important;`,
  'pb-5': css`padding-bottom: 3rem !important;`,

  'pl-1': css`padding-left: 0.25rem !important;`,
  'pl-2': css`padding-left: 0.5rem !important;`,
  'pl-3': css`padding-left: 1rem !important;`,
  'pl-4': css`padding-left: 1.5rem !important;`,
  'pl-5': css`padding-left: 3rem !important;`,

  'px-1': css`padding-left: 0.25rem !important; padding-right: 0.25rem !important;`,
  'px-2': css`padding-left: 0.5rem !important; padding-right: 0.5rem !important;`,
  'px-3': css`padding-left: 1rem !important; padding-right: 1rem !important;`,
  'px-4': css`padding-left: 1.5rem !important; padding-right: 1.5rem !important;`,
  'px-5': css`padding-left: 3rem !important; padding-right: 3rem !important;`,

  'py-1': css`padding-top: 0.25rem !important; padding-bottom: 0.25rem !important;`,
  'py-2': css`padding-top: 0.5rem !important; padding-bottom: 0.5rem !important;`,
  'py-3': css`padding-top: 1rem !important; padding-bottom: 1rem !important;`,
  'py-4': css`padding-top: 1.5rem !important; padding-bottom: 1.5rem !important;`,
  'py-5': css`padding-top: 3rem !important; padding-bottom: 3rem !important;`,

  'm-1': css`margin: 0.25rem !important;`,
  'm-2': css`margin: 0.5rem !important;`,
  'm-3': css`margin: 1rem !important;`,
  'm-4': css`margin: 1.5rem !important;`,
  'm-5': css`margin: 3rem !important;`,
  'm-auto': css`margin: auto !important;`,

  'mt-1': css`margin-top: 0.25rem !important;`,
  'mt-2': css`margin-top: 0.5rem !important;`,
  'mt-3': css`margin-top: 1rem !important;`,
  'mt-4': css`margin-top: 1.5rem !important;`,
  'mt-5': css`margin-top: 3rem !important;`,
  'mt-auto': css`margin-top: auto !important;`,

  'mr-1': css`margin-right: 0.25rem !important;`,
  'mr-2': css`margin-right: 0.5rem !important;`,
  'mr-3': css`margin-right: 1rem !important;`,
  'mr-4': css`margin-right: 1.5rem !important;`,
  'mr-5': css`margin-right: 3rem !important;`,
  'mr-auto': css`margin-right: auto !important;`,

  'mb-1': css`margin-bottom: 0.25rem !important;`,
  'mb-2': css`margin-bottom: 0.5rem !important;`,
  'mb-3': css`margin-bottom: 1rem !important;`,
  'mb-4': css`margin-bottom: 1.5rem !important;`,
  'mb-5': css`margin-bottom: 3rem !important;`,
  'mb-auto': css`margin-bottom: auto !important;`,

  'ml-1': css`margin-left: 0.25rem !important;`,
  'ml-2': css`margin-left: 0.5rem !important;`,
  'ml-3': css`margin-left: 1rem !important;`,
  'ml-4': css`margin-left: 1.5rem !important;`,
  'ml-5': css`margin-left: 3rem !important;`,
  'ml-auto': css`margin-left: auto !important;`,

  'mx-1': css`margin-left: 0.25rem !important; margin-right: 0.25rem !important;`,
  'mx-2': css`margin-left: 0.5rem !important; margin-right: 0.5rem !important;`,
  'mx-3': css`margin-left: 1rem !important; margin-right: 1rem !important;`,
  'mx-4': css`margin-left: 1.5rem !important; margin-right: 1.5rem !important;`,
  'mx-5': css`margin-left: 3rem !important; margin-right: 3rem !important;`,
  'mx-auto': css`margin-left: auto !important; margin-right: auto !important;`,

  'my-1': css`margin-top: 0.25rem !important; margin-bottom: 0.25rem !important;`,
  'my-2': css`margin-top: 0.5rem !important; margin-bottom: 0.5rem !important;`,
  'my-3': css`margin-top: 1rem !important; margin-bottom: 1rem !important;`,
  'my-4': css`margin-top: 1.5rem !important; margin-bottom: 1.5rem !important;`,
  'my-5': css`margin-top: 3rem !important; margin-bottom: 3rem !important;`,
  'my-auto': css`margin-top: auto !important; margin-bottom: auto !important;`
};

export default (props = {}) => {
  const padding = props.padding  || props.p;
  const margin = props.margin  || props.m;

  return {
    /* padding */
    [classes[`p-${sizes.padding[padding]}`]]: typeof padding === 'string',
    [classes[`pt-${sizes.padding[padding?.top]}`]]: padding?.top,
    [classes[`pr-${sizes.padding[padding?.right]}`]]: padding?.right,
    [classes[`pb-${sizes.padding[padding?.bottom]}`]]: padding?.bottom,
    [classes[`pl-${sizes.padding[padding?.left]}`]]: padding?.left,
    [classes[`px-${sizes.padding[padding?.x]}`]]: padding?.x,
    [classes[`py-${sizes.padding[padding?.y]}`]]: padding?.y,

    /* margin */
    [classes[`m-${sizes.margin[margin]}`]]: typeof margin === 'string',
    [classes[`mt-${sizes.margin[margin?.top]}`]]: margin?.top,
    [classes[`mr-${sizes.margin[margin?.right]}`]]: margin?.right,
    [classes[`mb-${sizes.margin[margin?.bottom]}`]]: margin?.bottom,
    [classes[`ml-${sizes.margin[margin?.left]}`]]: margin?.left,
    [classes[`mx-${sizes.margin[margin?.x]}`]]: margin?.x,
    [classes[`my-${sizes.margin[margin?.y]}`]]: margin?.y
  };
};
